import { useState, useEffect } from "react";
import styles from "../../BorrowerDetails.module.css";
import axios from "axios";
import { url } from "../../../../../App";
// import {
//   Accordion,
//   AccordionDetails,
//   AccordionSummary,
//   // MenuItem,
// } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { useBorrowerContext } from "../../store/borrower-details";
import { useRef } from "react";
import PDFViewer from "../PDFViewer/PDFViewer";
import { useNavigate } from "react-router";
import SingleDocModal from "./SingleDocModal";
import Cookies from "js-cookie";
import PDCModal from "./PDCModal/PDCModal";
// import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";
// import { Padding } from "@mui/icons-material";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";
// import Dialog from "@mui/material/Dialog";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import Checkbox from "@mui/material/Checkbox";
// import MultiDocsModal from "./MultiDocsModal";

const LoanDocsModal = ({
  loanDocsExist,
  loanID,
  closeModal,
  openLoader,
  closeLoader,
  permissions,
  isDisbursed,
}) => {
  const Navigate = useNavigate();
  const TOKEN = Cookies.get("Token");
  const EMAIL = Cookies.get("Email");
  const BORROWERNUMBER = localStorage.getItem("uniqueID");
  // const [applicationFormEsignModal, setApplicationFormEsignModal] =
  //   useState(false);
  // const [kfsEsignModal, setKFSEsignModal] = useState(false);
  // const [applicantType, setApplicantType] = useState({});
  // const [coapplicantEsign, setCoapplicantEsign] = useState(false);
  // const [isDownload, setIsDownload] = useState(true);
  // const [isDelete, setIsDelete] = useState(true);
  
  // const handleApplicationFormEsignModal = () => {
  //   // let text = `Are you sure you want to initiate esign?`;
  //   // if (!window.confirm(text)) {
  //   //   return;
  //   // }
  //   setApplicationFormEsignModal(true);
  // };

  // const handleApplicationEsignClose = () => {
  //   setApplicationFormEsignModal(false);
  // };
  // const handleKFSEsignModal = () => {
  //   setKFSEsignModal(true);
  // };

  // const handleKFSEsignClose = () => {
  //   setKFSEsignModal(false);
  // };
  // const handleChange = (event) => {
  //   setChecked(event.target.checked);
  // };
  // const handleCoapplicantEsign = () => {
  //   setCoapplicantEsign(!coapplicantEsign);
  // };
  // const [checked, setChecked] = React.useState(false);
  // const [loader, setLoader] = useState(false);
  // const [kfsLoader, setKfsLoader] = useState(false);
  // const [applicationFormLoader, setApplicationFormLoader] = useState(false);
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: `data:application/pdf;base64,${url}`,
  });
  const [singleDocModal, setSingleDocModal] = useState({
    open: false,
    doc: "",
    docType: "",
  });

  const [permission, setPermission] = useState({
    upload: false,
    view: false,
    download: false,
    delete: false,
    upload_kfs_letter: false,
    view_kfs_letter: false,
    download_kfs_letter: false,
    generate_kfs_letter: false,
    initiate_kfs_letter: false,
    signed_kfs_letter: false,
    delete_kfs_letter: false,
    upload_application_form_doc: false,
    view_application_form_doc: false,
    download_application_form_doc: false,
    generate_application_form_doc: false,
    initiate_application_form_doc: false,
    signed_application_form_doc: false,
    delete_loan_document: false,
    delete_loan_application_document: false
  });

  const [viewPdcModal, setViewPdcModal] = useState(false);
  // const [loanModal, setLoanModal] = useState(false);
  // const [miscDocs, setMiscDocs] = useState([]);
  // const [name, setName] = useState("");

  const openPdcModal = () => {
    setViewPdcModal(true);
  };
  const closePdcModal = () => {
    setViewPdcModal(false);
  };
  // const closeLoanModal = () => {
  //   // setLoanModal(false);
  //   // setIsDownload(true);
  //   setIsDelete(true);
  // };

  // console.log(isDelete, permission, "test123")
  useEffect(() => {
    try {
      setPermission({
        upload: permissions.add_loan_document,
        view: permissions.view_loan_document,
        download: permissions.download_loan_document,
        delete: permissions.delete_loan_document,
        upload_kfs_letter: permissions.upload_kfs_letter,
        view_kfs_letter: permissions.view_kfs_letter,
        download_kfs_letter: permissions.download_kfs_letter,
        generate_kfs_letter: permissions.generate_kfs_letter,
        initiate_kfs_letter: permissions.initiate_kfs_letter,
        signed_kfs_letter: permissions.signed_kfs_letter,
        upload_application_form_doc: permissions.upload_application_form_doc,
        view_application_form_doc: permissions.view_application_form_doc,
        download_application_form_doc:
          permissions.download_application_form_doc,
        generate_application_form_doc:
          permissions.generate_application_form_doc,
        initiate_application_form_doc:
          permissions.initiate_application_form_doc,
        signed_application_form_doc: permissions.signed_application_form_doc,
        delete_kfs_letter: permissions.delete_kfs_letter,
        delete_loan_application_document: permissions.delete_loan_application_document
      });
    } catch (err) {
      console.log(err);
    }
  }, [permissions]);

  const { updateBorrowerData, borrowerData } = useBorrowerContext();
  const { coapplicant } = borrowerData;
  const fetchedLoanDetails = borrowerData.loan;

  const CoapplicantsArray = [
    ...coapplicant
      .filter(
        (coapplicant) => coapplicant.coapplicant_loan_id === loanID.loan_id
      )
      .map((coapplicant) => coapplicant.coapplicant_name),
  ];
  console.log(CoapplicantsArray, loanID);
  console.log(fetchedLoanDetails);
  //eslint-disable-next-line
  const uploadLoanDocHandler = (e, docName) => {
    console.log(e);
    openLoader();
    try {
      let address = e.target.files[0];
      if (!address) {
        closeLoader();
        return;
      }
      const docType = address.name.split(".").pop();
      console.log(docType);
      if (docType !== "pdf" && docType !== "jpg" && docType !== "png") {
        closeLoader();
        toast.error("Please upload in PDF or Jpg or Png format only");
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(address);
      reader.onload = async (eve) => {
        const base64data = eve.target.result.split(",").pop();
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          fileName: base64data,
          loan_id: loanID.loan_id,
          doc_type: docType,
          doc_name: docName,
        };
        const res = await axios.post(url + "/loan/adddoc", req);
        if (!res.data.auth) {
          if (res.data.logout) {
            closeLoader();
            Navigate("/");
            return;
          }
          toast.error(res.data.message);
          closeLoader();
          return;
        }
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
        );
        if (!updateBorrower.data.auth) {
          closeLoader();
          return;
        }
        updateBorrowerData((prevState) => ({
          ...prevState,
          loan: updateBorrower.data.message.loan,
        }));

        toast.success(res.data.message);
        closeLoader();
        closeModal();
        return;
      };
    } catch (err) {
      toast.error("An error occoured");
      console.error(err);
      closeLoader();
      return;
    }
  };
  //eslint-disable-next-line
  const uploadPostDocHandler = (e, docName) => {
    // console.log(e)
    openLoader();
    try {
      let address = e.target.files[0];
      if (!address) {
        closeLoader();
        return;
      }
      const docType = address.name.split(".").pop();
      if (
        docType !== "jpg" &&
        docType !== "png" &&
        docType !== "jpeg" &&
        docType !== "pdf"
      ) {
        closeLoader();
        toast.error("Please upload in PDF or Jpg or Png format only");
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(address);
      reader.onload = async (eve) => {
        const base64data = eve.target.result.split(",").pop();
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          fileName: base64data,
          loan_id: loanID.loan_id,
          doc_type: docType,
          doc_name: docName,
        };
        const res = await axios.post(url + "/loan/adddoc", req);
        if (!res.data.auth) {
          if (res.data.logout) {
            closeLoader();
            Navigate("/");
            return;
          }
          toast.error(res.data.message);
          closeLoader();
          return;
        }
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
        );
        if (!updateBorrower.data.auth) {
          closeLoader();
          return;
        }
        updateBorrowerData((prevState) => ({
          ...prevState,
          loan: updateBorrower.data.message.loan,
        }));

        toast.success(res.data.message);
        closeLoader();
        closeModal();
        return;
      };
    } catch (err) {
      toast.error("An error occoured");
      console.error(err);
      closeLoader();
      return;
    }
  };

  const downloadLoanDocHandler = async (docName) => {
    let text = `Are you sure you want to download document?`;
    if (!window.confirm(text)) {
      return;
    }
    if (!loanID[docName]) {
      toast.error("No Document Found. Please upload");
      closeLoader();
      return;
    }
    openLoader();
    try {
      const req = {
        token: TOKEN,
        email: EMAIL,
        borrower_uniqueno: BORROWERNUMBER,
        doc_name: docName,
        loan_id: loanID.loan_id,
        doc_type: loanID[docName].doc_type,
        // docType: loanID.
      };
      const res = await axios.post(url + "/loan/downloaddoc", req);
      if (!res.data.auth) {
        if (res.data.logout) {
          toast.error(res.data.message);
          closeLoader();
          Navigate("/");
          return;
        }
        toast.error(res.data.message);
        closeLoader();
        return;
      }
      if (req.doc_type === "pdf") {
        const linkSource = `data:application/pdf;base64,${res.data.doc_base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${req.borrower_uniqueno} ${docName}.${req.doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        const linkSource = `data:image/${req.doc_type};base64,${res.data.doc_base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${req.borrower_uniqueno} ${docName}.${req.doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
      closeLoader();
    } catch (err) {
      console.error(err);
      closeLoader();
    }
  };

  const viewLoanDocHandler = async (docName) => {
    openLoader();
    if (!loanID[docName]) {
      toast.error("No Document Found. Please upload");
      closeLoader();
      return;
    }
    try {
      const req = {
        token: TOKEN,
        email: EMAIL,
        borrower_uniqueno: BORROWERNUMBER,
        doc_name: docName,
        loan_id: loanID.loan_id,
        doc_type: loanID[docName].doc_type,
      };
      const { data } = await axios.post(url + "/loan/viewdoc", req);
      if (!data.auth) {
        toast.error(data.message);
        closeLoader();
        return;
      }
      if (req.doc_type === "pdf") {
        setPdfModal((prevState) => ({
          ...prevState,
          open: true,
          data: `data:application/pdf;base64,${data.doc_base64}`,
        }));
      } else {
        setSingleDocModal((prevState) => ({
          ...prevState,
          open: true,
          docType: req.doc_type,
          doc: data.doc_base64,
        }));
      }
      closeLoader();
      // console.log(data);
    } catch (err) {
      console.error(err);
      closeLoader();
    }
  };

  // const viewLoanMiscDocHandler = async (docName) => {
  //   console.log(docName);
  //   // setLoader(true);
  //   if (!loanID[docName]) {
  //     toast.error("No Document Found. Please upload");
  //     closeLoader();
  //     return;
  //   }
  //   const cpvArray = fetchedLoanDetails.find((data) => {
  //     return data.loan_id.toString() === loanID.loan_id.toString();
  //   });
    
  //   console.log(cpvArray);
    
  //   if (!cpvArray) {
  //     toast.error("Document not found");
  //     return;
  //   }
    
  //   if (
  //     cpvArray[docName] === undefined ||
  //     !Array.isArray(cpvArray[docName])
  //   ) {
  //     toast.error("Document not found");
  //     return;
  //   }
  //   // console.log(cpvArray[docName]);
  //   const viewCpvArr = await Promise.all(
  //     cpvArray[docName].map(async (data, index) => {
  //       console.log(loanID[docName].doc_type);
  //       const req = {
  //         token: TOKEN,
  //         email: EMAIL,
  //         borrower_uniqueno: BORROWERNUMBER,
  //         doc_name: data.doc_name,
  //         loan_id: loanID.loan_id,
  //         doc_type: data.doc_type,
  //       };
  //       const docNameArr = data.doc_name
  //         .split("(")[0]
  //         .split("_")
  //         .map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  //       // console.log(docNameArr);
  //       const formattedDocName = `${docNameArr[0]} ${docNameArr[1]}`;
  //       setName(formattedDocName);

  //       // console.log(deleteReq)
  //       const res = await axios.post(url + "/loan/viewdoc", req);
  //       // console.log(req, res);

  //       const downloadCpvHandler = async () => {
  //         const downloadRes = await axios.post(url + "/loan/downloaddoc", req);
  //         if (!downloadRes.data.auth) {
  //           toast.error(downloadRes.data.message);
  //           return;
  //         }
  //         if (req.doc_type === "pdf") {
  //           const linkSource = `data:application/pdf;base64,${res.data.doc_base64}`;
  //           const downloadLink = document.createElement("a");
  //           const fileName = `${req.borrower_uniqueno} ${docName}.${req.doc_type}`;
  //           downloadLink.href = linkSource;
  //           downloadLink.download = fileName;
  //           downloadLink.click();
  //         } else {
  //           const linkSource = `data:image/${req.doc_type};base64,${res.data.doc_base64}`;
  //           const downloadLink = document.createElement("a");
  //           const fileName = `${req.borrower_uniqueno} ${docName}.${req.doc_type}`;
  //           downloadLink.href = linkSource;
  //           downloadLink.download = fileName;
  //           downloadLink.click();
  //         }
  //       };

  //       const deleteCpvHandelr = async () => {
  //         const text = `Are you sure you want to delete ${req.doc_name}?`;
  //         if (!window.confirm(text)) {
  //           return;
  //         }
  //         const deleteReq = {
  //           token: Cookies.get("Token"),
  //           email: Cookies.get("Email"),
  //           borrower_uniqueno: localStorage.getItem("uniqueID"),
  //           loan_id: loanID.loan_id,
  //           doc_arr: {
  //             location: data.location,
  //             doc_type: data.doc_type,
  //             doc_name: data.doc_name,
  //           },
  //         };
  //         const deleteRes = await axios.post(
  //           url + "/loan/deletedoc",
  //           deleteReq
  //         );
  //         // console.log(deleteReq)
  //         // console.log(deleteRes)
  //         if (!deleteRes.data.auth) {
  //           return toast.error(deleteRes.data.message);
  //         }
  //         toast.success(deleteRes.data.message);
  //         window.location.reload();
  //       };

  //       return {
  //         doc: res.data.doc_base64,
  //         docType: req.doc_type,
  //         download: downloadCpvHandler,
  //         delete: deleteCpvHandelr,
  //       };
  //     })
  //   );
  //   console.log(viewCpvArr);
  //   if (viewCpvArr.length === 0) {
  //     toast.error("No docs found");
  //     // setLoader(false);
  //     return;
  //   }
  //   setMiscDocs(viewCpvArr);
  //   // setViewCpvModal(true);
  //   // setLoader(false);
  //   // console.log(viewCpvArr)
  //   setLoanModal(true);
  // };

  const deleteLoanDocHandler = async (docName) => {
    const userConfirmed = window.confirm(
      `Are you sure you want to delete ${docName}?`
    );
    if (!userConfirmed) {
      return;
    }

    if (!loanID[docName]) {
      toast.error("No Document Found. Please upload");
      closeLoader();
      return;
    }

    try {
      const request = {
        token: TOKEN,
        email: EMAIL,
        borrower_uniqueno: BORROWERNUMBER,
        loan_id: loanID.loan_id,
        doc_arr: {
          doc_type: loanID[docName].doc_type,
          doc_name: docName,
        },
      };
      const { data: response } = await axios.post(
        url + "/loan/deletedoc",
        request
      );
      if (!response.auth) {
        toast.error(response.message);
        if (response.logout) {
          setTimeout(() => {
            Navigate("/");
          }, 1500);
        }
        return;
      }
      toast.success(response.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      console.log(err);
    }
  };

  // const fileInputRef = useRef(null);
  // const auditTrailRef = useRef(null);
  const promNoteRef = useRef(null);
  // const kfsUpload = useRef(null);
  // const kfsAuditTrailRef = useRef(null);
  // const applicationFormUpload = useRef(null);

  // const handleUpload = () => {
  //   fileInputRef.current.click();
  // };
  // const handleAuditUpload = () => {
  //   auditTrailRef.current.click();
  // };
  const handlerPromNoteRef = () => {
    promNoteRef.current.click();
  };
  // const handleKfsUpload = () => {
  //   let text = `Are you sure you want to upload kfs letter?`;
  //   if (!window.confirm(text)) {
  //     return;
  //   }
  //   kfsUpload.current.click();
  // };
  // const handleApplicationFormUpload = () => {
  //   let text = `Are you sure you want to upload application form?`;
  //   if (!window.confirm(text)) {
  //     return;
  //   }
  //   applicationFormUpload.current.click();
  // };

  const closePdfViewer = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const closeSingleDocModal = () => {
    setSingleDocModal((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  // const getApplicationForm = async (docType) => {
  //   let text = `Are you sure you want to generate document?`;
  //   if (!window.confirm(text)) {
  //     return;
  //   }
  //   if (docType === "KFS") {
  //     setKfsLoader(true);
  //   } else {
  //     setApplicationFormLoader(true);
  //   }
  //   try {
  //     const response = await axios.post(
  //       `${url}/application/generatedynamicfield`,
  //       {
  //         loan_id: loanID.loan_id,
  //         doc_type: docType,
  //       },
  //       {
  //         headers: {
  //           token: TOKEN,
  //           email: EMAIL,
  //         },
  //       }
  //     );

  //     if (response.data.auth) {
  //       toast.success(response.data.message);
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1000);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching application form:", error);
  //     toast.error("Failed to fetch application form. Please try again.");
  //   } finally {
  //     setKfsLoader(false);
  //     setApplicationFormLoader(false);
  //   }
  // };
  // const applicantChangeHandler = (e, applicant) => {
  //   const { value } = e.target;
  //   console.log(value);
  //   setApplicantType((prevValues) => ({
  //     ...prevValues,
  //     [applicant]: value,
  //   }));
  // };

  // const handleEsign = async (docType) => {
  //   openLoader();
  //   const reqtBody = {
  //     loanId: loanID.loan_id,
  //     esignReason: docType,
  //   };
  //   const Keys = Object.keys(applicantType);
  //   console.log(applicantType);
  //   let i = 2;
  //   // eslint-disable-next-line
  //   Keys.map((key, ind) => {
  //     if (key === "borrower") {
  //       reqtBody[`mobile1`] = loanID?.mobile;
  //       reqtBody[`name1`] =
  //         borrower.borrower_firstname + " " + borrower.borrower_lastname;
  //       reqtBody[`signerType1`] = applicantType[key];
  //     } else {
  //       // eslint-disable-next-line
  //       coapplicant.map((coapplcnt) => {
  //         if (coapplcnt.coapplicant_name === key) {
  //           reqtBody[`mobile${i}`] = coapplcnt.coapplicant_mobile;
  //           reqtBody[`name${i}`] = coapplcnt.coapplicant_name;
  //           reqtBody[`signerType${i}`] = applicantType[key];
  //         }
  //       });
  //       i++;
  //     }
  //   });
  //   if (reqtBody.signerType1 === undefined) {
  //     toast.error("Borrower is required");
  //     closeLoader();
  //     return;
  //   }
  //   console.log(reqtBody);
  //   try {
  //     const response = await axios.post(
  //       `${url}/loan/applicationform/esign`,
  //       reqtBody,
  //       {
  //         headers: {
  //           token: TOKEN,
  //           email: EMAIL,
  //         },
  //       }
  //     );
  //     if (response.data.auth) {
  //       toast.success(response.data.message);
  //       setApplicantType({});
  //       setApplicationFormEsignModal(false);
  //       setKFSEsignModal(false);

  //       const updateBorrower = await axios.post(
  //         url + "/borrower/borrowertoalldetails",
  //         {
  //           token: Cookies.get("Token"),
  //           email: Cookies.get("Email"),
  //           borrower_uniqueno: localStorage.getItem("uniqueID"),
  //         }
  //       );
  //       if (updateBorrower.data.auth) {
  //         updateBorrowerData((prevState) => ({
  //           ...prevState,
  //           loan: updateBorrower.data.message.loan,
  //         }));
  //       }
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       toast.error(error.response.data.message);
  //     } else {
  //       toast.error("Something went wrong. Please try again later");
  //     }
  //   } finally {
  //     closeLoader();
  //   }
  //   setApplicantType({});
  //   setApplicationFormEsignModal(false);
  //   setKFSEsignModal(false);
  // };

  // const GetSignedApplicationForm = async (signedReason) => {
  //   try {
  //     let text = `Are you sure you want to fetch latest details?`;
  //     if (!window.confirm(text)) {
  //       return;
  //     }
  //     const response = await axios.post(
  //       `${url}/loan/application-from/signed`,
  //       {
  //         loanId: loanID.loan_id,
  //         signedReason,
  //       },
  //       {
  //         headers: {
  //           token: TOKEN,
  //           email: EMAIL,
  //         },
  //       }
  //     );

  //     if (response.data.auth) {
  //       toast.success(response.data.message);
  //     } else {
  //       toast.error(response.data.message);
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       toast.error(error.response.data.message);
  //     } else {
  //       toast.error("Something went wrong. Please try again later");
  //     }
  //   }
  // };
  // const handleKfsTrailUpload = () => {
  //   kfsAuditTrailRef.current.click();
  // };

  return (
    <>
      <ToastContainer />
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfViewer} />
      )}
      {viewPdcModal && (
        <PDCModal loanId={loanID.loan_id} closeModal={closePdcModal} />
      )}

      {singleDocModal.open && (
        <SingleDocModal
          doc={singleDocModal.doc}
          docType={singleDocModal.docType}
          closeModal={closeSingleDocModal}
        />
      )}
      {/* {loanModal && (
        <MultiDocsModal array={miscDocs} closeModal={closeLoanModal} title={name} isDownload={isDownload} isDelete={isDelete} />
      )} */}
      <div className={styles.collateralDocumentsModal}>
        <div
          className={styles.collateralDocumentsModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div className={styles.collateralDocumentsModalContent}>
            <h3>Loan Documents</h3>
            {/* <Accordion>
              <AccordionSummary>
                <h4>Other Loan Files</h4>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  {/* <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Mandate Form:</p>
                      {loanDocsExist.mandateForm ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("mandate_form")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() => viewLoanDocHandler("mandate_form")}
                            >
                              View
                            </button>
                          )}
                          <button
                            className={styles.viewLoanBtn}
                            onClick={() => deleteLoanDocHandler("mandate_form")}
                          >
                            Delete
                          </button>
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div> */}
                  {/* <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Application Form:</p>
                      <div className={styles.loanBtns}>
                        <input
                          type="file"
                          className={styles.loanInputFile}
                          ref={applicationFormUpload}
                          onChange={(e) =>
                            uploadLoanDocHandler(e, "application_form")
                          }
                        />
                        {permission.upload_application_form_doc &&
                          !isDisbursed && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={handleApplicationFormUpload}
                            >
                              Upload
                            </button>
                          )}
                        {loanDocsExist.applicationForm ? (
                          <>
                            {permission.download_application_form_doc && (
                              <button
                                className={styles.DownloadLoanBtn}
                                onClick={() =>
                                  downloadLoanDocHandler("application_form")
                                }
                              >
                                Download
                              </button>
                            )}
                            {permission.view_application_form_doc && (
                              <button
                                className={styles.DownloadLoanBtn}
                                onClick={() =>{
                                  if(!permission.download_application_form_doc || permission.download_application_form_doc === false){
                                    setIsDownload(false)
                                  }
                                  if(!permission.delete_loan_application_document || permission.delete_loan_application_document === false){
                                    setIsDelete(false)
                                    console.log(false, "ok")
                                  }
                                  viewLoanMiscDocHandler("application_form")
                                }}
                              >
                                View
                              </button>
                            )}
                            {permission.generate_application_form_doc &&
                              !isDisbursed &&
                              (applicationFormLoader ? (
                                <button
                                  disabled
                                  className={styles.DownloadLoanBtn}
                                >
                                  <CircularProgress size={20} color="inherit" />
                                </button>
                              ) : (
                                <button
                                  className={styles.DownloadLoanBtn}
                                  onClick={() =>
                                    getApplicationForm("Application Form")
                                  }
                                >
                                  Regenerate
                                </button>
                              ))}
                            {permission.initiate_application_form_doc &&
                              !isDisbursed && (
                                <button
                                  className={styles.DownloadLoanBtn}
                                  onClick={handleApplicationFormEsignModal}
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: "auto", // Adjust width to fit text
                                  }}
                                >
                                  Initiate Esign
                                </button>
                              )}
                            {permission.initiate_application_form_doc &&
                              !isDisbursed && (
                                <button
                                  className={styles.DownloadLoanBtn}
                                  onClick={() =>
                                    GetSignedApplicationForm("Application Form")
                                  }
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: "auto", // Adjust width to fit text
                                  }}
                                >
                                  Fetch
                                </button>
                              )}
                            <Dialog
                              open={applicationFormEsignModal}
                              onClose={handleApplicationEsignClose}
                              PaperProps={{
                                component: "form",
                                onSubmit: (event) => {
                                  event.preventDefault();
                                  handleApplicationEsignClose();
                                },
                              }}
                            >
                              <DialogContent>
                                <DialogContentText>
                                  Do you want to initiate a E-Sign{" "}
                                  <Checkbox onChange={handleChange} />
                                </DialogContentText>
                                {checked ? (
                                  <div>
                                    <div>
                                      <label htmlFor="">
                                        <>
                                          {borrower.borrower_firstname}{" "}
                                          {borrower.borrower_lastname}
                                        </>
                                      </label>
                                      <TextField
                                        size="small"
                                        select
                                        className={styles.modalSel}
                                        variant="outlined"
                                        onChange={(e) =>
                                          applicantChangeHandler(e, "borrower")
                                        }
                                      >
                                        <MenuItem value="aadhaar">
                                          aadhaar
                                        </MenuItem>
                                        <MenuItem value="electronic">
                                          electronic
                                        </MenuItem>
                                      </TextField>
                                    </div>
                                    {CoapplicantsArray &&
                                      CoapplicantsArray.length > 0 && (
                                        <div>
                                          <label>
                                            Do you want to initiate an E-Sign
                                            for Co-Applicant
                                          </label>{" "}
                                          <Checkbox
                                            onChange={handleCoapplicantEsign}
                                          />
                                        </div>
                                      )}
                                    {coapplicantEsign ? (
                                      <div>
                                        {CoapplicantsArray.map(
                                          (item, index) => (
                                            <div key={index}>
                                              <label htmlFor="">
                                                <>{item}</>
                                              </label>
                                              <TextField
                                                size="small"
                                                select
                                                className={styles.modalSel}
                                                variant="outlined"
                                                onChange={(e) =>
                                                  applicantChangeHandler(
                                                    e,
                                                    item
                                                  )
                                                }
                                              >
                                                <MenuItem value="aadhaar">
                                                  aadhaar
                                                </MenuItem>
                                                <MenuItem value="electronic">
                                                  electronic
                                                </MenuItem>
                                              </TextField>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    ) : null}
                                    <Button
                                      onClick={() =>
                                        handleEsign("Application Form")
                                      }
                                    >
                                      Submit
                                    </Button>
                                  </div>
                                ) : null}
                              </DialogContent>
                            </Dialog>
                          </>
                        ) : (
                          <>
                            {!isDisbursed &&
                              (applicationFormLoader ? (
                                <button
                                  disabled
                                  className={styles.generatePDFBtn}
                                >
                                  <CircularProgress size={20} color="inherit" />
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    getApplicationForm("Application Form")
                                  }
                                  className={styles.generatePDFBtn}
                                >
                                  Generate
                                </button>
                              ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div> */}
                  {/* <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Download SOA:</p>
                      
                      {loanDocsExist?.soa ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("application_form")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                viewLoanDocHandler("application_form")
                              }
                            >
                              View
                            </button>
                          )}
                          {permission.delete && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("application_form")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div>
                  <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Foreclosure Letter:</p>
                    
                      {loanDocsExist?.soa ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("application_form")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                viewLoanDocHandler("application_form")
                              }
                            >
                              View
                            </button>
                          )}
                          {permission.delete && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("application_form")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div> */}
{/*
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <p>Miscellaneous Documents:</p>
                    <div style={{ marginLeft: "9.2vw" }}>
                      <input
                        type="file"
                        onChange={(e) =>
                          uploadLoanDocHandler(e, "loan_mis_doc")
                        }
                        id="uploadLogo"
                        hidden
                      />
                      <label
                        htmlFor="uploadLogo"
                        className={styles.styledButton}
                      >
                        Upload
                      </label>
                    </div>

                    {loanDocsExist?.miscDoc ? (
                      <div>
                        {permission.view && (
                          <button
                            onClick={() =>
                              viewLoanMiscDocHandler("loan_mis_doc")
                            }
                            className={styles.styledButton}
                          >
                            View
                          </button>
                        )}
                      </div>
                    ) : (
                      <p>No Documents Found</p>
                    )}
                  </div>
                </div>
              </AccordionDetails>
            </Accordion> */}
            {/* <Accordion>
              <AccordionSummary>
                <h4>Loan Files</h4>
              </AccordionSummary>
              <AccordionDetails> */}
                <div>
                  {/* <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Sanction Letter:</p>
                      <input
                        type="file"
                        onChange={(e) =>
                          uploadLoanDocHandler(e, "mandate_form")
                        }
                      />
                      {loanDocsExist?.sanctionLetter ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("saction_letter")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                viewLoanDocHandler("saction_letter")
                              }
                            >
                              View
                            </button>
                          )}
                          {permission.delete && !isDisbursed && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("saction_letter")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div>
                  <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>KFS Letter:</p>
                      <div className={styles.loanBtns}>
                        <input
                          type="file"
                          className={styles.loanInputFile}
                          ref={kfsUpload}
                          onChange={(e) =>
                            uploadLoanDocHandler(e, "kfs_letter")
                          }
                        />
                        {permission.upload_kfs_letter && !isDisbursed && (
                          <button
                            className={styles.DownloadLoanBtn}
                            onClick={handleKfsUpload}
                          >
                            Upload
                          </button>
                        )}
                        {loanDocsExist?.kfsLetter ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("kfs_letter")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() => viewLoanDocHandler("kfs_letter")}
                            >
                              View
                            </button>
                          )}
                          {permission.delete && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() => deleteLoanDocHandler("kfs_letter")}
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                        {loanDocsExist.kfsLetter ? (
                          <>
                            {permission.download_kfs_letter && (
                              <button
                                className={styles.DownloadLoanBtn}
                                onClick={() =>
                                  downloadLoanDocHandler("kfs_letter")
                                }
                              >
                                Download
                              </button>
                            )}
                            {permission.view_kfs_letter && (
                              <button
                                className={styles.DownloadLoanBtn}
                                onClick={() => {
                                  if(!permission.download_kfs_letter || permission.download_kfs_letter === false){
                                    setIsDownload(false)
                                  }
                                  if(!permission.delete_kfs_letter || permission.delete_kfs_letter === false){
                                    setIsDelete(false)
                                  }
                                  viewLoanMiscDocHandler("kfs_letter")}}
                              >
                                View
                              </button>
                            )}
                            {permission.generate_kfs_letter &&
                              !isDisbursed &&
                              (kfsLoader ? (
                                <button
                                  disabled
                                  className={styles.DownloadLoanBtn}
                                >
                                  <CircularProgress size={20} color="inherit" />
                                </button>
                              ) : (
                                <button
                                  className={styles.DownloadLoanBtn}
                                  onClick={() => getApplicationForm("KFS")}
                                >
                                  Regenerate
                                </button>
                              ))}
                            {permission.initiate_kfs_letter && !isDisbursed && (
                              <button
                                className={styles.DownloadLoanBtn}
                                onClick={handleKFSEsignModal}
                                style={{
                                  whiteSpace: "nowrap",
                                  width: "auto", // Adjust width to fit text
                                }}
                              >
                                Initiate Esign
                              </button>
                            )}
                            {permission.initiate_kfs_letter && !isDisbursed && (
                              <button
                                className={styles.DownloadLoanBtn}
                                onClick={() => GetSignedApplicationForm("KFS")}
                                style={{
                                  whiteSpace: "nowrap",
                                  width: "auto", // Adjust width to fit text
                                }}
                              >
                                Fetch
                              </button>
                            )}
                            {permission.initiate_kfs_letter && (
                              <button
                                className={styles.DownloadLoanBtn}
                                style={{
                                  whiteSpace: "nowrap",
                                  width: "auto",
                                }}
                                onClick={() => {
                                  if (!fetchedLoanDetails[0]?.kfs_sign_link) {
                                    toast.error("No link found.");
                                    return;
                                  }
                                  navigator.clipboard
                                    .writeText(
                                      fetchedLoanDetails[0]?.kfs_sign_link
                                    )
                                    .then(() => {
                                      toast.success("Link Copied.");
                                    })
                                    .catch((err) => {
                                      console.error("Failed to copy: ", err);
                                    });
                                }}
                              >
                                Copy Link
                              </button>
                            )}
                            <Dialog
                              open={kfsEsignModal}
                              onClose={handleKFSEsignClose}
                              PaperProps={{
                                component: "form",
                                onSubmit: (event) => {
                                  event.preventDefault();
                                  handleKFSEsignClose();
                                },
                              }}
                            >
                              <DialogContent>
                                <DialogContentText>
                                  Do you want to initiate a E-Sign{" "}
                                  <Checkbox onChange={handleChange} />
                                </DialogContentText>
                                {checked ? (
                                  <div>
                                    <div>
                                      <label htmlFor="">
                                        <>
                                          {borrower.borrower_firstname}{" "}
                                          {borrower.borrower_lastname}
                                        </>
                                      </label>
                                      <TextField
                                        size="small"
                                        select
                                        className={styles.modalSel}
                                        variant="outlined"
                                        onChange={(e) =>
                                          applicantChangeHandler(e, "borrower")
                                        }
                                      >
                                        <MenuItem value="aadhaar">
                                          aadhaar
                                        </MenuItem>
                                        <MenuItem value="electronic">
                                          electronic
                                        </MenuItem>
                                      </TextField>
                                    </div>
                                    {CoapplicantsArray &&
                                      CoapplicantsArray.length > 0 && (
                                        <div>
                                          <label>
                                            Do you want to initiate an E-Sign
                                            for Co-Applicant
                                          </label>{" "}
                                          <Checkbox
                                            onChange={handleCoapplicantEsign}
                                          />
                                        </div>
                                      )}
                                    {coapplicantEsign ? (
                                      <div>
                                        {CoapplicantsArray.map(
                                          (item, index) => (
                                            <div key={index}>
                                              <label htmlFor="">
                                                <>{item}</>
                                              </label>
                                              <TextField
                                                size="small"
                                                select
                                                className={styles.modalSel}
                                                variant="outlined"
                                                onChange={(e) =>
                                                  applicantChangeHandler(
                                                    e,
                                                    item
                                                  )
                                                }
                                              >
                                                <MenuItem value="aadhaar">
                                                  aadhaar
                                                </MenuItem>
                                                <MenuItem value="electronic">
                                                  electronic
                                                </MenuItem>
                                              </TextField>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    ) : null}
                                    <Button onClick={() => handleEsign("KFS")}>
                                      Submit
                                    </Button>
                                  </div>
                                ) : null}
                              </DialogContent>
                            </Dialog>
                          </>
                        ) : (
                          <>
                            {!isDisbursed &&
                              (kfsLoader ? (
                                <button
                                  disabled
                                  className={styles.generatePDFBtn}
                                >
                                  <CircularProgress size={20} color="inherit" />
                                </button>
                              ) : (
                                <button
                                  onClick={() => getApplicationForm("KFS")}
                                  className={styles.generatePDFBtn}
                                >
                                  Generate
                                </button>
                              ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>KFS Audit Trail:</p>
                      <div
                        className={styles.uploadDiv}
                        style={{ marginLeft: "2vw" }}
                      >
                        <input
                          type="file"
                          className={styles.loanInputFile}
                          ref={kfsAuditTrailRef}
                          onChange={(e) =>
                            uploadLoanDocHandler(e, "kfs_audit_trail")
                          }
                        />
                        {permission.upload_kfs_letter && !isDisbursed && (
                          <button
                            className={styles.uploadLoanButton}
                            onClick={handleKfsTrailUpload}
                          >
                            Upload
                          </button>
                        )}
                      </div>
                      {loanDocsExist?.kfsTrailLetter ? (
                        <div className={styles.loanBtns}>
                          {permission.download_kfs_letter && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("kfs_audit_trail")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view_kfs_letter && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>{
                                if(!permission.download_kfs_letter || permission.download_kfs_letter === false){
                                  setIsDownload(false)
                                }
                                if(!permission.delete_kfs_letter || permission.delete_kfs_letter === false){
                                  setIsDelete(false)
                                }
                                viewLoanMiscDocHandler("kfs_audit_trail")
                              }}
                            >
                              View
                            </button>
                          )}
                          {permission.delete_kfs_letter && !isDisbursed && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("kfs_audit_trail")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div> */}

                  <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Demand Promissory Note:</p>
                      <div className={styles.uploadDiv}>
                        <input
                          type="file"
                          className={styles.loanInputFile}
                          ref={promNoteRef}
                          onChange={(e) =>
                            uploadLoanDocHandler(e, "demand_promissory_note")
                          }
                        />
                        {permission.upload && !isDisbursed && (
                          <button
                            className={styles.uploadLoanButton}
                            onClick={handlerPromNoteRef}
                          >
                            Upload
                          </button>
                        )}
                      </div>
                      {loanDocsExist?.promissoryNote ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("demand_promissory_note")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                viewLoanDocHandler("demand_promissory_note")
                              }
                            >
                              View
                            </button>
                          )}
                          {permission.delete && !isDisbursed && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("demand_promissory_note")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div>
                  <div className={styles.pdcBtnDiv}>
                    <p>PDC:</p>
                    <button className={styles.PDCButton} onClick={openPdcModal}>
                      View
                    </button>
                  </div>
                  {/* <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Loan Agreement:</p>
                      <div className={styles.uploadDiv}>
                        <input
                          type="file"
                          className={styles.loanInputFile}
                          ref={fileInputRef}
                          onChange={(e) =>
                            uploadLoanDocHandler(e, "loan_agreement")
                          }
                        />
                        {permission.upload && (
                          <button
                            className={styles.uploadLoanButton}
                            onClick={handleUpload}
                          >
                            Upload
                          </button>
                        )}
                      </div>
                      {loanDocsExist?.loanAgreement ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("loan_agreement")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                viewLoanDocHandler("loan_agreement")
                              }
                            >
                              View
                            </button>
                          )}
                          {permission.delete && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("loan_agreement")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div>
                  <div className={styles.loanDocDiv}>
                    <div className={styles.uploadLoanDoc}>
                      <p>Audit Trail:</p>
                      <div
                        className={styles.uploadDiv}
                        style={{ marginLeft: "2vw" }}
                      >
                        <input
                          type="file"
                          className={styles.loanInputFile}
                          ref={auditTrailRef}
                          onChange={(e) =>
                            uploadLoanDocHandler(e, "audit_trail")
                          }
                        />
                        {permission.upload && (
                          <button
                            className={styles.uploadLoanButton}
                            onClick={handleAuditUpload}
                          >
                            Upload
                          </button>
                        )}
                      </div>
                      {loanDocsExist?.auditTrail ? (
                        <div className={styles.loanBtns}>
                          {permission.download && (
                            <button
                              className={styles.DownloadLoanBtn}
                              onClick={() =>
                                downloadLoanDocHandler("audit_trail")
                              }
                            >
                              Download
                            </button>
                          )}
                          {permission.view && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() => viewLoanDocHandler("audit_trail")}
                            >
                              View
                            </button>
                          )}
                          {permission.delete && (
                            <button
                              className={styles.viewLoanBtn}
                              onClick={() =>
                                deleteLoanDocHandler("audit_trail")
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      ) : (
                        <p>No Documents Found</p>
                      )}
                    </div>
                  </div> */}
                </div>
              {/* </AccordionDetails>
            </Accordion> */}
            <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanDocsModal;
